import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes, authRoutes } from './routes';

const NonAuthLayout = lazy(() => import('./layouts/NonAuthLayout'));
const ProtectedRoute = lazy(() => import('./layouts/AuthLayout'));

function App() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-white">Loading...</div>}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<NonAuthLayout />}>
          {publicRoutes.map((route, idx) => (
            route.index ? (
              <Route key={`pub-${idx}`} index element={route.element} />
            ) : (
              <Route key={`pub-${idx}`} path={route.path} element={route.element} />
            )
          ))}
        </Route>

        {/* Protected Routes */}
        <Route path="/" element={<ProtectedRoute />}>
          {authRoutes.map((route, idx) => (
            route.index ? (
              <Route key={`auth-${idx}`} index element={route.element} />
            ) : (
              <Route key={`auth-${idx}`} path={route.path} element={route.element} />
            )
          ))}
        </Route>

        {/* Catch-all: redirect unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
